import { render } from "./InvestigationTypeCard.vue?vue&type=template&id=eba96f10"
import script from "./InvestigationTypeCard.vue?vue&type=script&lang=js"
export * from "./InvestigationTypeCard.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__